<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Informes</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Dashboard</a></li>
                    <li class="breadcrumb-item active">Informes</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
    <div class="row  justify-content-center">
        <div class="col-xl-5 col-md-12">
            <form [formGroup]="InformeVentaForm" *ngIf="InformeVentaForm">
                <div class="card card-dark">
                    <div class="card-header">
                        <h2 class="card-title text-bold py-2" style="font-size: 1.5rem;">Informe Mensual Ventas</h2>
                        <div class="card-tools">
                            <button type="button" class="btn btn-info btn-block btn-lg"
                                (click)="descargaInformeVenta(InformeVentaForm.value)">
                                <i class="fas fa-file-download"></i>&nbsp; Descargar
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Mes</label>
                                    <select class="custom-select" id="month" name="month"
                                        [formControl]="InformeVentaForm.get('month')">
                                        <option value="1">Enero</option>
                                        <option value="2">Febrero</option>
                                        <option value="3">Marzo</option>
                                        <option value="4">Abril</option>
                                        <option value="5">Mayo</option>
                                        <option value="6">Junio</option>
                                        <option value="7">Julio</option>
                                        <option value="8">Agosto</option>
                                        <option value="9">Septiembre</option>
                                        <option value="10">Octubre</option>
                                        <option value="11">Noviembre</option>
                                        <option value="12">Diciembre</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Año</label>
                                    <select class="custom-select" id="year" name="year"
                                        [formControl]="InformeVentaForm.get('year')">
                                        <option *ngFor="let item of this.Func.rangeYear()" [value]="item">
                                            {{item}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-xl-5 col-md-12">
            <form [formGroup]="InformeClienteForm" *ngIf="InformeClienteForm">
                <div class="card card-dark">
                    <div class="card-header">
                        <h2 class="card-title text-bold py-2" style="font-size: 1.5rem;">Informe por Cliente</h2>
                        <div class="card-tools">
                            <button type="button" class="btn btn-info btn-block btn-lg"
                                (click)="descargaInformeCliente(InformeClienteForm.value)">
                                <i class="fas fa-file-download"></i>&nbsp; Descargar
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <app-typeahead label="Cliente" idForm="InputCliente" [data]="clientes"
                                    optField="nombre_completo" [autocomplete]="false"
                                    placeholder="Selecciona un cliente"
                                    [control]="InformeClienteForm.get('nombre_cliente')"
                                    (onSelectItem)="onSelectItemCliente($event)"></app-typeahead>
                                <input type="hidden" id="InputIdCliente" name="InputIdCliente"
                                    [formControl]="InformeClienteForm.get('id_cliente')" autocomplete="off">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-xl-5 col-md-12">
            <div class="card card-dark">
                <div class="card-header">
                    <h2 class="card-title text-bold py-2" style="font-size: 1.5rem;">Informe Lista Precios</h2>
                    <div class="card-tools">
                        <button type="button" class="btn btn-info btn-block btn-lg"
                            (click)="descargaListadoProductos()">
                            <i class="fas fa-file-download"></i>&nbsp; Descargar
                        </button>
                    </div>
                </div>
            </div>
        </div><div class="col-xl-5 col-md-12">
            <form [formGroup]="InformeArqueo" *ngIf="InformeArqueo">
                <div class="card card-dark">
                    <div class="card-header">
                        <h2 class="card-title text-bold py-2" style="font-size: 1.5rem;">Informe Arqueo Mensual</h2>
                        <div class="card-tools">
                            <button type="button" class="btn btn-info btn-block btn-lg"
                                (click)="descargaInformeArqueo(InformeArqueo.value)">
                                <i class="fas fa-file-download"></i>&nbsp; Descargar
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Mes</label>
                                    <select class="custom-select" id="month" name="month"
                                        [formControl]="InformeArqueo.get('month')">
                                        <option value="1">Enero</option>
                                        <option value="2">Febrero</option>
                                        <option value="3">Marzo</option>
                                        <option value="4">Abril</option>
                                        <option value="5">Mayo</option>
                                        <option value="6">Junio</option>
                                        <option value="7">Julio</option>
                                        <option value="8">Agosto</option>
                                        <option value="9">Septiembre</option>
                                        <option value="10">Octubre</option>
                                        <option value="11">Noviembre</option>
                                        <option value="12">Diciembre</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Año</label>
                                    <select class="custom-select" id="year" name="year"
                                        [formControl]="InformeArqueo.get('year')">
                                        <option *ngFor="let item of this.Func.rangeYear()" [value]="item">
                                            {{item}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>